import Api from "./api.jsx";
import * as Constants from "../../../consts/Constants.js";
import auth from "../../auth/service";

const PLACES_ROLE = 5011;

class PlacesService {

	constructor(baseUrl) {
		this.api = new Api(baseUrl);
	}

	canAdmin() {
		return auth.hasRole(PLACES_ROLE);
	}

}

export default new PlacesService(Constants.FINAL_URL_MAP_PLACES);